"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourStepEditor = void 0;
const react_1 = require("@thesisedu/react");
const icons_1 = require("@thesisedu/react/icons");
const react_2 = __importDefault(require("react"));
const StepTypeConfig_1 = require("./StepTypeConfig");
const StepTypeSelect_1 = require("./StepTypeSelect");
const TourStepSettingsModal_1 = require("./TourStepSettingsModal");
function TourStepEditor({ prefix, onRemove, onMoveDown, canMoveDown, onMoveUp, canMoveUp, }) {
    const [visible, setVisible] = react_2.default.useState(false);
    return (react_2.default.createElement(react_1.VSpaced, { align: 'stretch', space: '@size-xs' },
        react_2.default.createElement(TourStepSettingsModal_1.TourStepSettingsModal, { prefix: prefix, visible: visible, onCancel: () => setVisible(false) }),
        react_2.default.createElement(react_1.HSpaced, null,
            react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.type`, required: { value: true, message: 'A type is required.' } },
                react_2.default.createElement(StepTypeSelect_1.StepTypeSelect, null)),
            react_2.default.createElement(react_1.Space, null),
            canMoveUp ? (react_2.default.createElement(react_1.Tooltip, { title: 'Move up' },
                react_2.default.createElement(react_1.Button, { icon: react_2.default.createElement(icons_1.ArrowUp, null), onClick: e => {
                        e.preventDefault();
                        onMoveUp();
                    } }))) : null,
            canMoveDown ? (react_2.default.createElement(react_1.Tooltip, { title: 'Move down' },
                react_2.default.createElement(react_1.Button, { icon: react_2.default.createElement(icons_1.ArrowDown, null), onClick: e => {
                        e.preventDefault();
                        onMoveDown();
                    } }))) : null,
            react_2.default.createElement(react_1.Tooltip, { title: 'Additional Settings' },
                react_2.default.createElement(react_1.Button, { icon: react_2.default.createElement(icons_1.Settings, null), onClick: e => {
                        e.preventDefault();
                        setVisible(true);
                    } })),
            react_2.default.createElement(react_1.Tooltip, { title: 'Remove this step' },
                react_2.default.createElement(react_1.Button, { icon: react_2.default.createElement(icons_1.Trash, null), danger: true, onClick: e => {
                        e.preventDefault();
                        onRemove();
                    } }))),
        react_2.default.createElement(StepTypeConfig_1.StepTypeConfig, { prefix: prefix }),
        react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.message`, label: 'Message', required: { value: true, message: 'A message is required.' }, extra: 'Supports Markdown' },
            react_2.default.createElement(react_1.Input.TextArea, { placeholder: 'This is my **message.**', autoSize: { minRows: 2, maxRows: 10 } }))));
}
exports.TourStepEditor = TourStepEditor;
//# sourceMappingURL=TourStepEditor.js.map